<template>
    <div>
        <BriefWithModal
            :next="nextPage"
            :captureFrontUrl="captureFrontUrl"
            pictureCover
        />
    </div>
</template>
<script>
import { BriefWithModal } from '@skeepers/platform-framework/views/desktop';
import { SolutionConsumer } from '@skeepers/platform-framework/mixins';
import { FRONT_CAPTURE } from '../../config';

export default {
    name: 'BriefWrapper',
    components: { BriefWithModal },
    mixins: [SolutionConsumer],
    data () {
        return {
            captureFrontUrl: FRONT_CAPTURE,
        };
    },
    props: {
        next: {
            type: String,
            default: 'contract',
        },
    },
    computed: {
        nextPage () {
            return this.$route.query.next || this.next;
        },
    },
};
</script>
